import Icon from '../components/Icon.vue'

Icon.register({
  dice: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M592 192H473.3C485.9 221.6 480.4 257.2 456.3 281.3L320 417.6V464C320 490.5 341.5 512 368 512H592C618.5 512 640 490.5 640 464V240C640 213.5 618.5 192 592 192zM480 376C466.8 376 456 365.3 456 352 456 338.7 466.8 328 480 328S504 338.7 504 352C504 365.3 493.3 376 480 376zM433.6 189.3L258.7 14.4C239.5-4.8 208.5-4.8 189.3 14.4L14.4 189.3C-4.8 208.5-4.8 239.5 14.4 258.7L189.3 433.6C208.5 452.8 239.5 452.8 258.7 433.6L433.6 258.7C452.8 239.5 452.8 208.5 433.6 189.3zM96 248C82.8 248 72 237.3 72 224 72 210.7 82.8 200 96 200S120 210.7 120 224C120 237.3 109.3 248 96 248zM224 376C210.8 376 200 365.3 200 352 200 338.7 210.8 328 224 328S248 338.7 248 352C248 365.3 237.3 376 224 376zM224 248C210.8 248 200 237.3 200 224 200 210.7 210.8 200 224 200S248 210.7 248 224C248 237.3 237.3 248 224 248zM224 120C210.8 120 200 109.3 200 96 200 82.7 210.8 72 224 72S248 82.7 248 96C248 109.3 237.3 120 224 120zM352 248C338.8 248 328 237.3 328 224 328 210.7 338.8 200 352 200S376 210.7 376 224C376 237.3 365.3 248 352 248z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/dice.js
// module id = qZyf
// module chunks = 144